import Vue from 'vue';
import { getEnv } from 'ecx.saigon.ui.common';
import jwtTokenProvider, {displayLogoutDialog} from './jwt-token-provider';
import apolloClient from '@eui-util/vue-apollo-client';

function isAccessTokenExpired() {
  return jwtTokenProvider.isExpired;
}

async function getAccessToken() {
  const auth = Vue.prototype.$auth;
  if (jwtTokenProvider.isSilentRefreshReady) {
    const accessToken = await auth.getTokenSilently({ ignoreCache: true });
    jwtTokenProvider.setToken(accessToken);
    return accessToken;
  }

  return auth.accessToken;
}

let httpEndpoint;

async function getEndpoint() {
  if (!httpEndpoint) {
    const { VUE_APP_GRAPHQL_HTTP } = await getEnv();
    httpEndpoint = VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql';
  }

  return httpEndpoint;
}

export default async function coreApolloClient() {
  if (isAccessTokenExpired()) {
    return displayLogoutDialog();
  }

  const opts = {
    uri: await getEndpoint(),
    headers: {},
    getAccessToken: async () => `Bearer ${await getAccessToken()}`,
    errorCallback: throwGQLErrorMessage
  };

  return apolloClient(opts);
}

export async function corePublicApolloClient() {
  const opts = {
    uri: await getEndpoint(),
    headers: {},
    errorCallback: throwGQLErrorMessage
  }

  return apolloClient(opts);
}

export const throwGQLErrorMessage = (error = {}) => {
  // If the error directly contains a message we will strip and throw it
  if (error.message) {
    throw error;
  }

  // If there are any GQL errors, we will throw the first
  if (Array.isArray(error.graphQLErrors) && error.graphQLErrors.length) {
    return throwGQLErrorMessage(error.graphQLErrors[0]);
  }
};

